import axios from "axios";
import { getToken } from "./wapAuth";
import { decodeToken, removeInfo } from "@/utils/auth";
import { MessageBox, Message } from "element-ui";
import store from "@/store";

let error_token = false;
// Create axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_V2,
  timeout: 60 * 10 * 1000, // Request timeout
  headers: {
    Authorization: `Bearer ` + getToken().token,
    "Access-Control-Allow-Origin": "*" // Allow CORS
  }
});

service.interceptors.request.use(
  config => {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let route_token = params.get("token");
    const { token, vga, bank_id } = getToken();
    const user = decodeToken(token);
    if (vga || token)
      config.params = {
        ...config.params,
        uid: vga || user.vga
      };

    if (bank_id) config.params = { ...config.params, bank_id: bank_id };
    else config.params = { ...config.params, is_wap: 1 };
    if (token || route_token)
      config.headers["Authorization"] = `Bearer ${token || route_token}`;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.error_code === 498) {
      reLoginDialog();
      error_token = true;
      return;
    }
    error_token = false;
    return response.data;
  },
  error => {
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000
    // });
    return Promise.reject(error);
  }
);
const reLoginDialog = () => {
  if (error_token) return;
  MessageBox.confirm(
    "Phiên đăng nhập của quý khách đã kết thúc, Quý khách có thể chọn Hủy để tiếp tục ở lại trang web, hoặc chọn Đăng nhập lại.",
    "Thông báo",
    {
      confirmButtonText: "Đăng nhập lại",
      cancelButtonText: "Hủy",
      type: "warning"
    }
  ).then(() => {
    removeInfo();
    store.dispatch("showLoginDialog");
    // location.reload();
  });
};
export default service;
